<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

let type = "TRUCK_TRAILER";

export default {
    init: async (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        $('#spinner').modal('toggle');

        setTimeout(async function(){
            let query = {
                type: type
            };
            let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
            if (response.status==200){
                payload.user = response.result;

                if (payload.user.companyUser && payload.user.companyUser.subtype == "ADMIN" && payload.user.companyUser.company){

                    payload.data.manufacturerFamilies = payload.user.companyUser.company.manufacturerFamilies;
                    
                }
                
                let responseManu = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), query, `${Endpoints.parts.manufacturer.listByType}`)).data;
                let responseFamilies = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), query, `${Endpoints.parts.families.listByType}`)).data;
                payload.manufacturers = responseManu.results;
                payload.families = responseFamilies.results;
            }
            $('#spinner').modal('toggle');
        }, 100);
    },
    methods:{
        save: function(e){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            console.log(this.data.document);
            this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            console.log(this.data.document);
            Request.do(this, 'PUT', Request.getDefaultHeader(this), this.data, `${Endpoints.companies.perfilParts}${this.data.document}`,
                (companyResponse)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    this.flashMessage.success(
                            this.configMessage(this.$t('string.msg.perfilTruckTrailer.register.title.success'), this.$t('string.msg.perfilTruckTrailer.register.message.success'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.perfilTruckTrailer.register.message.success')),
                            destroyed: this.clearText()
                        }) 
                },
                (error)=>{//ERROR CALLBACK
                    console.log(JSON.stringify(error));
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    
            });
            e.preventDefault();
        },
        add: function(e){
            let state = this;
            if ($("#manufacturer option:selected" ).val()=='*'){
                this.manufacturers.forEach(function (item) {
                    addManu(item._id, item);
                });
            }else if (parseInt($("#manufacturer option:selected" ).val())>-1 && state.data.families.length>0){
                addManu(state.manufacturer);
                $("#manufacturer option:selected" ).val(-1)
                state.manufacturer = -1;
                state.data.families = [];
                state.isAllSelected = false;
            }else{
                alert(state.$t("string.msg.parts.perfil.truck.table.select.at.least"))
            }

            function addManu(manufacturerSelected, element){
                let index = -1;
                for (let i=0;i<state.data.manufacturerFamilies.length; i++){
                    let manufacturer = state.data.manufacturerFamilies[i];
                    if (manufacturer && manufacturer.manufacturer && manufacturer.manufacturer._id == manufacturerSelected){
                        index = i;
                        for (let x=0;x<manufacturer.families.length; x++){
                            let family = manufacturer.families[x];
                            let indexFamily = state.data.families.findIndex(x => x == family._id);
                            
                            if (indexFamily>-1)
                                state.data.families.splice(indexFamily, 1);
                        }
                        for (let x=0;x<state.data.families.length; x++){
                            if (state.data.families && state.data.families[x]!=null){
                                let family = {
                                    _id: state.data.families[x],
                                    name: $('#'+state.data.families[x]).attr('name')
                                };
                                manufacturer.families.push(family);
                            }
                        }
                        break;
                    }
                }
                if (index==-1){
                    let manufacturer = {
                        manufacturer: {
                            _id: manufacturerSelected,
                            name: element ? element.name : $("#manufacturer option:selected" ).text()
                        },
                        type: type,
                        families: []
                    };
                    for (let x=0;x<state.data.families.length; x++){
                        if (state.data.families[x]!=null){
                            let family = {
                                _id: state.data.families[x],
                                name: $('#'+state.data.families[x]).attr('name'),
                                type: type,
                            };
                            manufacturer.families.push(family);
                        }
                    }
                    
                    state.data.manufacturerFamilies.push(JSON.parse(JSON.stringify(manufacturer)));
                }
            }

            this.valuekey = this.valuekey+1;
            e.preventDefault();
        },
        remove: function(_idManufacter, _idFamily){
            let indexManu = this.data.manufacturerFamilies.findIndex(x => x.manufacturer._id == _idManufacter);
            
            let indexFamily = this.data.manufacturerFamilies[indexManu].families.findIndex(x => x._id == _idFamily);
            if (indexFamily>-1){
                this.data.manufacturerFamilies[indexManu].families.splice(indexFamily, 1);
                if (this.data.manufacturerFamilies[indexManu].families.length==0){
                    this.data.manufacturerFamilies.splice(indexManu, 1);
                }
            }
        },
        selectAll: function(){
            if (!this.isAllSelected){
                let state = this;
                this.data.families = [];
                this.families.forEach(function (item) {
                    if (item && item._id)
                        state.data.families.push(item._id);
                });
                this.isAllSelected = true;
            }else{
                this.data.families = [];
                this.isAllSelected = false;
            }
            
        },
        listManufacturer: function () {
            // console.log(this.data.manufacturerFamilies.filter(i => i.type === type));
            return this.data.manufacturerFamilies.filter(i => i.type === type)
        },
        listFamilies: function (item) {
            return item.families.filter(i => i.type === type)
        },
        isAdminMaster: function(){
            if (this.user){
                return this.user.companyUser && this.user.companyUser.subtype === "ADMIN_MASTER";
            }
            return false;
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
             this.data.families = [];
            this.isAllSelected = false;
            this.data.fantasyName = Common.camelize(this.data.fantasyName);
            this.data.socialName = Common.camelize(this.data.socialName);
            this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            
            console.log(this.data);

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        clearForm: function(){
            this.data = {}
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        camelize: Common.toUpperCase,
        getType: type,
    }
}
</script>
